import {
  LayoutDashboard, Gamepad2, Sparkles, Wallet, Trophy, Layers3, Flame, Radio, Store, Users, Brain, Target,
} from "lucide-react";

export const MENU = [
  { label: "Overview" },
  { title: "Dashboard", href: "/dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { title: "Scoreboard", href: "/scores", icon: Radio, testid: "nav-scores" },
  { title: "Daily Picks", href: "/daily-picks", icon: Flame, testid: "nav-daily-picks" },
  { title: "Live Odds", href: "/games", icon: Gamepad2, testid: "nav-games" },
  { title: "Line Shop", href: "/bookmakers", icon: Store, testid: "nav-bookmakers" },
  { title: "Players", href: "/players", icon: Users, testid: "nav-players" },
  { title: "Simulator", href: "/simulate", icon: Sparkles, testid: "nav-simulate" },
  { title: "Parlay Builder", href: "/parlay", icon: Layers3, testid: "nav-parlay" },
  { label: "Account" },
  { title: "My Bets", href: "/my-bets", icon: Wallet, testid: "nav-mybets" },
  { title: "CLV Report", href: "/clv", icon: Target, testid: "nav-clv" },
  { title: "Rankings", href: "/rankings", icon: Trophy, testid: "nav-rankings" },
  { title: "Self-Learning", href: "/factors", icon: Brain, testid: "nav-factors" },
];
